import { DatePipe, NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, OnInit, Signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { BackendService } from '@core/services';
import { BaseComponent } from '@shared/classes';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { HowToPlayComponent } from '@shared/components/how-to-play/how-to-play.component';
import { TemplateComponent } from '@shared/components/template/template.component';
import { Pages, RETAILERS } from '@shared/constants';
import {
  ContactUsType,
  HelpPage,
  NavBar,
  ScriptPageKeys,
} from '@shared/models';
import { JoinPipe, VariableReplacementPipe } from '@shared/pipes';

import { ContactFormComponent } from './contact-form/contact-form.component';
import { ContactLinkComponent } from './contact-link/contact-link.component';
import { FaqVariantsComponent } from './faq-variants/faq-variants.component';

@Component({
  selector: 'b2c-help',
  styleUrl: './help.component.scss',
  templateUrl: './help.component.html',
  imports: [
    RouterLink,
    DatePipe,
    FooterComponent,
    NgOptimizedImage,
    TemplateComponent,
    HowToPlayComponent,
    FaqVariantsComponent,
    ContactLinkComponent,
    ContactFormComponent,
    JoinPipe,
    VariableReplacementPipe,
  ],
})
export class HelpComponent extends BaseComponent implements OnInit {
  public expandedAccordions: Set<number> = new Set<number>();
  public ContactUsType: typeof ContactUsType = ContactUsType;
  public retailerName: RETAILERS = this.environment.retailerName;
  public config: HelpPage = this.loyaltyChallengeConfig.pages.help;
  public navbar: NavBar = this.loyaltyChallengeConfig.components.navbar;

  // PROVIDERS
  private readonly router: Router = inject(Router);
  private readonly backendService: BackendService = inject(BackendService);

  public untienotsId: string = this.backendService.untienotsId;
  public showTutorial: Signal<boolean> = computed(() => {
    return this.dataService.checkTutorial(
      this.config.header.howToPlay.specificDisplayCondition
    );
  });

  ngOnInit(): void {
    this.dataService.currentPage.set(Pages.HELP);
    this.metaService.setMeta(this.config.meta);
    this.taggingService.loadScriptForPage(ScriptPageKeys.HELP_PAGE);
  }

  goBack() {
    if (this.untienotsId) {
      this.router.navigate([this.backendService.untienotsId, 'current']);
    } else this.router.navigate(['login']);
  }
}
